import {get, post} from '@/libs/http'

export const logout = () => post('logout', {})
export const registeUser = p => post('register', p)